import React from 'react';

const SingleSkeletonProduct = ({color}) => {
    return (
        <div className={"single-skeleton-product position-relative skeleton-loading br-4 "+ color}>
            <div className="price-sk skeleton-loading position-absolute"></div>
            <div className="image-sk br-4 skeleton-loading"></div>
            <div className="text text--1 br-2 xmt-6 skeleton-loading"></div>
            <div className="text text--2 br-2 xmt-2 skeleton-loading"></div>
            <div className="color-range d-flex justify-content-center align-items-center xmt-4">
                <div className="color-sk skeleton-loading"></div>
                <div className="color-sk skeleton-loading"></div>
                <div className="color-sk skeleton-loading"></div>
            </div>
        </div>
    );
};

export default SingleSkeletonProduct;
